var React = require('react');

function MailLocal (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M23.825.813H3.92A3.05 3.05 0 00.875 3.858v12.998a3.05 3.05 0 003.046 3.046h19.904a3.05 3.05 0 003.046-3.046V3.859A3.05 3.05 0 0023.825.813zm1.015 16.044c0 .56-.455 1.015-1.015 1.015H3.92c-.56 0-1.015-.455-1.015-1.015V3.859c0-.56.455-1.016 1.015-1.016h19.904c.56 0 1.015.456 1.015 1.016v12.998z","key":0}),React.createElement("path",{"d":"M24.668 2.079l-10.795 8.029-10.795-8.03-1.212 1.63 12.007 8.931 12.007-8.93z","key":1})]));
}

MailLocal.defaultProps = {"width":"27","height":"20","viewBox":"0 0 27 20"};

module.exports = MailLocal;

MailLocal.default = MailLocal;
